import { CORBAN_SUBMODULES } from 'interfaces/submodules'

export const CORBAN_CHANNEL_TYPE_MAP: { [key: string]: string } = {
  empresa: 'Consignado',
  'empresa etrabalhador': 'Crédito Trabalhador',
}

export const ALLOWED_CORBAN_SUBMODULES = [
  CORBAN_SUBMODULES.CEP,
  CORBAN_SUBMODULES.CPUBLICO,
  CORBAN_SUBMODULES.CT,
] as const

export type TCorbanSubModule = typeof ALLOWED_CORBAN_SUBMODULES[number]
